import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { deleteProgramMember } from '../../services';
import { getProgramUsersInfiniteQueryKey } from '../keys';

export const useDeleteProgramMemberMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { programId: string; userId: string }>({
    /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
    async mutationFn({ programId, userId }) {
      await deleteProgramMember({
        body: {
          data: [{ entity_ids: [programId], entity_type: 'Program', roles: [], user_id: userId }],
        },
        routeParams: { programId, userId },
      });
    },
    /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
    async onSuccess(_, { programId }) {
      await queryClient.invalidateQueries({
        queryKey: getProgramUsersInfiniteQueryKey({ filter: { programId } }),
      });
    },
  });
};
